(function () {
  'use strict';
  function init() {
    const newsletterHashes = ['#newsletter', '#shopify-section-sections--32460939821398__newsletter_Y6na3N'];
    if (newsletterHashes.includes(location.hash)) {
      const settleAnchor = () => requestAnimationFrame(() => requestAnimationFrame(() => {
        if (newsletterHashes.includes(location.hash)) document.getElementById(location.hash.slice(1))?.scrollIntoView({block:'start',behavior:'instant'});
      }));
      if (document.readyState === 'complete') settleAnchor();
      else window.addEventListener('load',settleAnchor,{once:true});
    }
    document.querySelectorAll('[data-wd-demo]').forEach(button=>{
      if(button.dataset.ready)return;
      button.dataset.ready='true';
      button.addEventListener('click',()=>{
        const section=button.dataset.wdDemoSection,media=button.dataset.wdDemo;
        const thumbnail=document.querySelector('[data-target="'+section+'-'+media+'"] button');
        if(thumbnail){thumbnail.click();document.getElementById('MediaGallery-'+section)?.scrollIntoView({behavior:'smooth',block:'center'});}
      });
    });
    document.querySelectorAll('[data-wd-purchase]').forEach(root => {
      if (root.dataset.ready) return;
      const input = document.getElementById('Quantity-' + root.dataset.section);
      const quantity = document.getElementById('Quantity-Form-' + root.dataset.section);
      const submit = document.getElementById('ProductSubmitButton-' + root.dataset.section);
      const bar = root.querySelector('[data-wd-mobile]');
      if (!input || !quantity || !submit || !bar) return;
      root.dataset.ready = 'true';
      root.closest('product-info')?.classList.add('wd-purchase-section');
      const buttons = [...root.querySelectorAll('[data-wd-qty]')];
      const custom = root.querySelector('[data-wd-custom]');
      const value = bar.querySelector('[data-wd-mobile-value]');
      const label = bar.querySelector('[data-wd-mobile-label]');
      const chooseLabel = label.textContent;
      const format = amount => new Intl.NumberFormat(document.documentElement.lang || 'da', {style:'currency',currency:root.dataset.currency || 'DKK',maximumFractionDigits:2}).format(amount / 100);
      const summary = (template,count,total) => template.replace('[count]', count).replace('[total]', format(total));
      let chosen = false, added = false, primaryVisible = true, frame, requestedCount = Number(input.value) || 1;
      const visible = element => {
        if (!element || element.hidden) return false;
        const style = getComputedStyle(element), rect = element.getBoundingClientRect();
        return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0' && rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight && rect.right > 0 && rect.left < innerWidth;
      };
      function visibility() {
        frame = null;
        const blocked = [...document.querySelectorAll('dialog[open], [role="dialog"], #shopify-pc__banner, #shopify-pc__prefs__dialog, #cart-notification.active, cart-drawer.active, product-modal[open], details[open] .menu-drawer, #newsletter, footer')].some(visible) || [...document.querySelectorAll('video')].some(video=>!video.paused&&visible(video));
        const show = matchMedia('(max-width:749px)').matches && !primaryVisible && !blocked && !submit.disabled;
        if (bar.hidden === show) bar.hidden = !show;
        document.body.classList.toggle('wd-mobile-visible',show);
      }
      function schedule() { if (!frame) frame = requestAnimationFrame(visibility); }
      function sync() {
        const count = Number(input.value) || 1;
        buttons.forEach(button => {
          const qty=Number(button.dataset.wdQty),min=Number(input.min)||1,max=Number(input.max)||Infinity,step=Number(input.step)||1;
          button.setAttribute('aria-pressed',String(qty===count));button.disabled=qty<min||qty>max||(qty-min)%step!==0;
        });
        const text = summary(root.dataset.selected,count,count * Number(root.dataset.price));
        root.querySelector('[data-wd-selection]').textContent = text;
        if (!added) { value.textContent=text;label.textContent=chosen?root.dataset.addLabel:chooseLabel;bar.href='#'+root.id; }
        schedule();
      }
      buttons.forEach(button => button.addEventListener('click',()=>{
        chosen=true;added=false;quantity.hidden=true;custom.setAttribute('aria-expanded','false');
        input.value=button.dataset.wdQty;
        input.dispatchEvent(new Event('input',{bubbles:true}));input.dispatchEvent(new Event('change',{bubbles:true}));sync();
      }));
      custom.addEventListener('click',()=>{quantity.hidden=false;custom.setAttribute('aria-expanded','true');input.focus();input.select();});
      function quantityChanged(){chosen=true;added=false;requestedCount=Number(input.value)||1;sync();}
      input.addEventListener('input',quantityChanged);input.addEventListener('change',quantityChanged);
      bar.addEventListener('click',event=>{
        if (added) return;
        event.preventDefault();
        if (chosen) {submit.click();return;}
        root.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth',block:'center'});
        buttons[0].focus({preventScroll:true});
      });
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.quantityUpdate,()=>queueMicrotask(()=>{
          const min=Number(input.min)||1,max=Number(input.max)||Infinity,step=Number(input.step)||1;
          requestedCount=Math.max(min,Math.min(max,requestedCount));
          requestedCount=min+Math.floor((requestedCount-min)/step)*step;
          input.value=String(requestedCount);sync();
        }));
        subscribe(PUB_SUB_EVENTS.cartUpdate, async event => {
          if (event.source !== 'product-form') return;
          try {
            const response=await fetch((window.Shopify?.routes?.root || '/')+'cart.js',{credentials:'same-origin',cache:'no-store'});
            if(!response.ok)return;
            const cart=await response.json();
            added=true;value.textContent=summary(root.dataset.cartSummary,cart.item_count,cart.total_price);label.textContent=root.dataset.cartLabel;bar.href=root.dataset.cartUrl;schedule();
          } catch {}
        });
      }
      new IntersectionObserver(entries=>{primaryVisible=entries.some(entry=>entry.isIntersecting);schedule();},{threshold:0}).observe(submit);
      new MutationObserver(schedule).observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['class','style','open','hidden','aria-hidden','disabled']});
      window.addEventListener('resize',schedule);
      window.addEventListener('scroll',schedule,{passive:true});
      document.addEventListener('play',schedule,true);document.addEventListener('pause',schedule,true);
      if(new URLSearchParams(location.search).get('offer')?.toUpperCase()==='JULIE2FOR1' || location.hash.toLowerCase()==='#julie-2-for-1'){
        input.value='2';chosen=true;root.querySelector('[data-wd-campaign]').hidden=false;
        input.dispatchEvent(new Event('change',{bubbles:true}));
      }
      root.querySelector('.wd-kit-options').hidden=false;custom.hidden=false;quantity.hidden=true;sync();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();
